import React from 'react';

class InvoiceItemMap extends React.Component {
    render() {
        return (
            <div className='dms-body'>
                {this.props.children}
            </div>
        )
    }
};
export default InvoiceItemMap;


// WEBPACK FOOTER //
// ./src/routes/invoiceItemMap/index.js